// import React from 'react';
// import { useTranslation } from 'react-i18next';
// import classes from './OnboardingPage.module.css';
// import Layout2 from '../components/Layout2';

// /**
//  * Onboarding screen shown before the subscription form.
//  * - onNext: called when the user taps "Next" (parent hides this page)
//  */
// const OnboardingPage = ({ onNext }) => {
//     const { t } = useTranslation();

//     const steps = [
//         t("onboarding_step_1", "Enter your MTN number and pick a daily or weekly pack."),
//         t("onboarding_step_2", "Answer quiz questions each day to collect points."),
//         t("onboarding_step_3", "The best players win prizes every day."),
//     ];

//     return (
//         <div className={classes.container}>
//             <div className={classes.hero}>
//                 <img
//                     src="/assets/images/onboarding.png"
//                     alt="MTN Massano"
//                     className={classes.hero_logo}
//                     draggable={false}
//                 />
//             </div>

//             <div className={classes.intro}>
//                 <h1 className={classes.title}>
//                     {t("onboarding_title", "Welcome to Massano")}
//                 </h1>
//                 <p className={classes.subtitle}>
//                     {t("onboarding_subtitle", "Test your knowledge every day and win prizes.")}
//                 </p>
//             </div>

//             <ol className={classes.steps}>
//                 {steps.map((step, index) => (
//                     <li key={index} className={classes.step}>
//                         <span className={classes.step_number}>{index + 1}</span>
//                         <p className={classes.step_text}>{step}</p>
//                     </li>
//                 ))}
//             </ol>

//             <button
//                 type="button"
//                 className={classes.next_btn}
//                 onClick={onNext}
//             >
//                 {t("onboarding_next", "Next")}
//             </button>

//             <div className={classes.footer}>
//                 <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
//             </div>
//         </div>
//     );
// };

// export default OnboardingPage;


import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaQuestion, FaStopwatch, FaTrophy } from 'react-icons/fa';
import classes from './OnboardingPage.module.css';


const OnboardingPage = ({ onNext }) => {
    const { t } = useTranslation();

    return (
        <div className={classes.page}>
            {/* Hero photo — already contains the Apprenez → Jouez → Gagnez artwork */}
            <img
                src="/assets/images/onboarding.png"
                alt=""
                className={classes.hero}
                draggable={false}
            />

            {/* White card that overlaps the bottom of the photo */}
            <div className={classes.card}>
                <h1 className={classes.title}>
                    <span className={classes.title_main}>
                        {t("161")}
                    </span>
                    <span className={classes.title_sub}>
                        {t("162")}
                    </span>
                </h1>

                <p className={classes.subtitle}>
                        {t("163")}
                </p>

                <ul className={classes.features}>

                    <li  className={classes.feature}>
                        <span className={classes.feature_icon} aria-hidden="true">
                            <FaQuestion />
                        </span>
                        <div className={classes.feature_body}>
                            <p className={classes.feature_title}>{t("164")}</p>
                            <p className={classes.feature_text}>{t("165")}</p>
                        </div>
                    </li>

                    <li  className={classes.feature}>
                        <span className={classes.feature_icon} aria-hidden="true">
                            <FaStopwatch />
                        </span>
                        <div className={classes.feature_body}>
                            <p className={classes.feature_title}>{t("166")}</p>
                            <p className={classes.feature_text}>{t("167")}</p>
                        </div>
                    </li>

                    <li  className={classes.feature}>
                        <span className={classes.feature_icon} aria-hidden="true">
                            <FaTrophy />
                        </span>
                        <div className={classes.feature_body}>
                            <p className={classes.feature_title}>{t("168")}</p>
                            <p className={classes.feature_text}>{t("169")}</p>
                        </div>
                    </li>
               
                </ul>
            </div>

            {/* Bottom action bar */}
            <div className={classes.action_bar}>
                <button type="button" className={classes.next_btn} onClick={onNext}>
                   {t("170")}
                </button>
            </div>
        </div>
    );
};

export default OnboardingPage;